"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVariantLegalities = instanceOfVariantLegalities;
exports.VariantLegalitiesFromJSON = VariantLegalitiesFromJSON;
exports.VariantLegalitiesFromJSONTyped = VariantLegalitiesFromJSONTyped;
exports.VariantLegalitiesToJSON = VariantLegalitiesToJSON;
exports.VariantLegalitiesToJSONTyped = VariantLegalitiesToJSONTyped;
/**
 * Check if a given object implements the VariantLegalities interface.
 */
function instanceOfVariantLegalities(value) {
    if (!('commander' in value) || value['commander'] === undefined)
        return false;
    if (!('pauperCommanderMain' in value) || value['pauperCommanderMain'] === undefined)
        return false;
    if (!('pauperCommander' in value) || value['pauperCommander'] === undefined)
        return false;
    if (!('oathbreaker' in value) || value['oathbreaker'] === undefined)
        return false;
    if (!('predh' in value) || value['predh'] === undefined)
        return false;
    if (!('brawl' in value) || value['brawl'] === undefined)
        return false;
    if (!('vintage' in value) || value['vintage'] === undefined)
        return false;
    if (!('legacy' in value) || value['legacy'] === undefined)
        return false;
    if (!('premodern' in value) || value['premodern'] === undefined)
        return false;
    if (!('modern' in value) || value['modern'] === undefined)
        return false;
    if (!('pioneer' in value) || value['pioneer'] === undefined)
        return false;
    if (!('standard' in value) || value['standard'] === undefined)
        return false;
    if (!('pauper' in value) || value['pauper'] === undefined)
        return false;
    return true;
}
function VariantLegalitiesFromJSON(json) {
    return VariantLegalitiesFromJSONTyped(json, false);
}
function VariantLegalitiesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'commander': json['commander'],
        'pauperCommanderMain': json['pauperCommanderMain'],
        'pauperCommander': json['pauperCommander'],
        'oathbreaker': json['oathbreaker'],
        'predh': json['predh'],
        'brawl': json['brawl'],
        'vintage': json['vintage'],
        'legacy': json['legacy'],
        'premodern': json['premodern'],
        'modern': json['modern'],
        'pioneer': json['pioneer'],
        'standard': json['standard'],
        'pauper': json['pauper'],
    };
}
function VariantLegalitiesToJSON(json) {
    return VariantLegalitiesToJSONTyped(json, false);
}
function VariantLegalitiesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'commander': value['commander'],
        'pauperCommanderMain': value['pauperCommanderMain'],
        'pauperCommander': value['pauperCommander'],
        'oathbreaker': value['oathbreaker'],
        'predh': value['predh'],
        'brawl': value['brawl'],
        'vintage': value['vintage'],
        'legacy': value['legacy'],
        'premodern': value['premodern'],
        'modern': value['modern'],
        'pioneer': value['pioneer'],
        'standard': value['standard'],
        'pauper': value['pauper'],
    };
}
//# sourceMappingURL=variantLegalities.js.map